<template>
    <footer class="section footer-area footer-bg">
        <!-- Footer Top -->
        <div class="footer-top ptb_50">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 col-lg-3">
                        <!-- Footer Items -->
                        <div class="footer-items">
                            <!-- Logo -->
                            <a class="navbar-brand" href="/">
                                <img class="logo" src="/assets/img/logo_horizontal.svg" alt="">
                            </a>
                            <p class="footer-desc text-white-50">{{ $t('footer.desc') }}</p>
                            <ul>
                                <li class="py-2"><a class="text-white-50" :href="iosDownloadUrl" target="_blank"><img width="130" src="/assets/img/ios_download.svg" alt=""></a></li>
                                <li class="py-2"><a class="text-white-50" :href="androidDownloadUrl" target="_blank"><img width="130" src="/assets/img/google_play_download.svg" alt=""></a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3 offset-lg-3">
                        <!-- Footer Items -->
                        <div class="footer-items">
                            <!-- Footer Title -->
                            <h3 class="footer-title text-white mb-2">{{ $t('footer.productHelp') }}</h3>
                            <ul>
                                <li class="py-2"><a class="text-white-50" href="/privacy-policy">{{ $t('footer.privacyPolicy') }}</a></li>
                                <!-- <li class="py-2"><a class="text-white-50" href="#">{{ $t('footer.termsConditions') }}</a></li> -->
                                <li class="py-2"><a class="text-white-50" href="/contact">{{ $t('header.contact') }}</a></li>
                                <li class="py-2"><a class="text-white-50" href="/help/delete-account">{{ $t('footer.deleteAccount') }}</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <!-- Footer Items -->
                        <div class="footer-items">
                            <!-- Footer Title -->
                            <h3 class="footer-title text-white mb-2">{{ $t('footer.contactInfo') }}</h3>
                            <p class="text-white-50">{{ $t('footer.email') }}</p>
                            <p class="text-white-50">{{ $t('footer.officeHour') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Footer Bottom -->
        <div class="footer-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <!-- Copyright Area -->
                        <div class="copyright-area d-flex flex-wrap justify-content-center justify-content-sm-between text-center py-4">
                            <!-- Copyright Left -->
                            <div class="copyright-left text-white-50">&copy; {{ $t('footer.copyright') }}</div>
                            <!-- Social Icons -->
                            <div class="social-icons d-flex">
                                <a class="tiktok" target="_blank" href="https://www.tiktok.com/@forwardreceipts">
                                    <img src="/assets/img/social/tiktok_100.svg" alt="TikTok" />
                                    <img src="/assets/img/social/tiktok_100.svg" alt="TikTok" />
                                </a>
                                <a class="instagram" target="_blank"  href="https://www.instagram.com/forwardreceipts/">
                                    <img src="/assets/img/social/instagram_100.svg" alt="Instagram" />
                                    <img src="/assets/img/social/instagram_100.svg" alt="Instagram" />
                                </a>
                                <a class="youtube" target="_blank"  href="https://www.youtube.com/@forwardreceipts">
                                    <img src="/assets/img/social/youtube_100.svg" alt="YouTube" />
                                    <img src="/assets/img/social/youtube_100.svg" alt="YouTube" />
                                </a>
                                <a class="medium" target="_blank"  href="https://medium.com/@forwardreceipts">
                                    <img src="/assets/img/social/medium_100.svg" alt="Medium" />
                                    <img src="/assets/img/social/medium_100.svg" alt="Medium" />
                                </a>
                                <a class="reddit" target="_blank"  href="https://www.reddit.com/user/ForwardReceipts/">
                                    <img src="/assets/img/social/reddit_100.svg" alt="Reddit" />
                                    <img src="/assets/img/social/reddit_100.svg" alt="Reddit" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    computed: {
        iosDownloadUrl() {
            return process.env.VUE_APP_IOS_DOWNLOAD_URL;
        },
        androidDownloadUrl() {
            return process.env.VUE_APP_ANDROID_DOWNLOAD_URL;
        }
    }
}
</script>

<style scoped>
.footer-area {
    background: var(--blue1) !important;
}

.footer-top {
    padding: 66px 0;
}

.navbar-brand .logo {
    max-height: 36px;
}

.footer-desc {
    line-height: 1.7;
    margin: 18px 0 20px;
    max-width: 280px;
}

.footer-title {
    font-size: 16px;
    font-weight: 800;
    margin-bottom: 18px !important;
}

.footer-items a,
.footer-items p {
    font-size: 14px;
}

.copyright-area {
    align-items: center;
    border-top: 1px solid rgba(255, 255, 255, 0.12);
    font-size: 13px;
    gap: 16px;
}

.copyright-area .social-icons {
    justify-content: center;
}

@media (max-width: 575px) {
    .copyright-area {
        flex-direction: column;
    }
}

</style>
